import { NotFound } from "@dgs/core";
import { FC } from "react";
import { Route, Routes } from "react-router";
import { LocationList } from "./LocationList";

export const LocationPage: FC = () => {
	return (
		<Routes>
			<Route index element={<LocationList />} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
};
